import { Button } from "@radix-ui/themes";
import { routes } from "../../routes";
import { HeaderWithMenu } from "../../shared/components/header-with-menu";
import { IconQrCodeScanner } from "../../shared/components/icons";
import { useQRCodeScanner } from "../../shared/hooks/use-qr-code-scanner";

export const MapHeader: React.FC = () => {
  const { scanQRCode, isLoading } = useQRCodeScanner();

  return (
    <HeaderWithMenu
      title="Stationen"
      homePath={routes.home}
      menuItems={[]}
      primaryAction={
        <Button
          variant="solid"
          highContrast
          color="gray"
          loading={isLoading}
          onClick={() => void scanQRCode()}
        >
          <IconQrCodeScanner width="18" height="18" />
          Scannen
        </Button>
      }
    />
  );
};
